import React, { ReactElement, useContext } from 'react';
import { t } from 'i18next';
import styled from 'styled-components';
import { screen } from '../../common/breakpoints';
import { VerticalSpacing, HorizontalSpacing, Heading } from '../../common/spacings';
import { NeutralColors } from '../../common/colors';
import { GiveawayContext } from '../../services/GiveawayContextService';

const StyledContainer = styled.section`
  text-align: left;
  display: none;
  font-size: ${Heading.XS};

  @media ${screen.l} {
    display: inline-block;
  }
`;

const StyledText = styled.div`
  padding-bottom: ${VerticalSpacing.S};
  padding-top: ${VerticalSpacing.S};
  padding-left: ${HorizontalSpacing.S};

  @media screen and ${screen.m} {
    padding-bottom: ${VerticalSpacing.M};
    padding-top: ${VerticalSpacing.M};
    padding-left: ${HorizontalSpacing.M};
  }

  @media screen and ${screen.l} {
    padding-bottom: ${VerticalSpacing.L};
    padding-top: ${VerticalSpacing.L};
    padding-left: ${HorizontalSpacing.L};
  }

  @media screen and ${screen.xl} {
    padding-bottom: ${VerticalSpacing.XL};
    padding-top: ${VerticalSpacing.XL};
    padding-left: ${HorizontalSpacing.XL};
  }

  h2 {
    font-weight: normal;
    color: ${NeutralColors.Black};
  }

  h2:first-of-type {
    font-weight: bold;
    color: ${NeutralColors.Black};
  }
`;

export const YourCar = (): ReactElement => {
  const giveawayResponse = useContext(GiveawayContext);
  const { carModel } = giveawayResponse;

  return (
    <StyledContainer data-testid="yourcar-container">
      {carModel && (
        <StyledText data-testid="yourcar-text-container">
          <h2>{t('header.model')}</h2>
          <h2 data-testid="yourcar-model">{carModel}</h2>
        </StyledText>
      )}
    </StyledContainer>
  );
};
